import { SSEModel } from "./SSEModel";
import { SSEEventCallback } from "./SSE.domain";

export class SSEAdapter {
  private sseModel: SSEModel;

  constructor(sseModel: SSEModel) {
    this.sseModel = sseModel;
  }

  /**
   * Initializes the SSE connection for a specific topic.
   * @param topic - Topic to listen to (default: 'assignments')
   */
  initialize(topic: string = "assignments"): void {
    this.sseModel.initEventSource(topic);
  }

  /**
   * Subscribes to a specific event type.
   * @param entityType - Entity type (e.g. ASSIGNMENT, PROVIDER) or 'all'
   * @param callback - Callback invoked on event
   * @param topic - Topic to listen to (default: 'assignments')
   */
  subscribe(entityType: string, callback: SSEEventCallback, topic: string = "assignments"): void {
    this.sseModel.addEventListener(entityType, callback, topic);
  }

  /**
   * Unsubscribes from an event type.
   * @param entityType - Entity type
   * @param callback - Callback to remove
   */
  unsubscribe(entityType: string, callback: SSEEventCallback): void {
    this.sseModel.removeEventListener(entityType, callback);
  }

  /**
   * Closes the SSE connection.
   * @param topic - Specific topic to close (if omitted, closes all)
   */
  close(topic?: string): void {
    this.sseModel.closeEventSource(topic);
  }
}
